
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var Homepage = require('../../components/homepage/homepage');
module.exports = Homepage;
  let __hot__
  
  __registry__.register('homepage/homepage', module.exports, __hot__)
  